export const columnLayout = [
  {
    dataField: "plantCd",
    headerText: "사업장",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "plantNm",
    headerText: "사업장",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspCd",
    headerText: "검수구분",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspCdNm",
    headerText: "검수구분",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspDt",
    headerText: "입고일자",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "vhclNo",
    headerText: "차량번호",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemCd",
    headerText: "품목",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemNm",
    headerText: "품목",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vndrCd",
    headerText: "업체명",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vndrNm",
    headerText: "업체명",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnCd",
    headerText: "반품내역",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnCdNm",
    headerText: "반품내역",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnRsn",
    headerText: "반품사유",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnRsnNm",
    headerText: "반품사유",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "dcsnItemCd",
    headerText: "검수등급",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dcsnItemNm",
    headerText: "검수등급",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "workerId",
    headerText: "검수자",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "workerNm",
    headerText: "검수자",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
];
